"use client"
import { Home, Wallet, RefreshCw, User, Settings, HelpCircle, LogOut, ChevronLeft, ChevronRight } from "lucide-react"
import { capitalizeFirstLetter } from "../../../../utility/Helper1"
import { allRemoteSettingsSelect } from "../../../../redux/selectors";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { authActions } from "../../../../redux/actions";



export function Sidebar({ activeTab, setActiveTab, open, setOpen }) {

  const site_settings = useSelector(allRemoteSettingsSelect);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const doLogOutNowNow = () => {
    dispatch(authActions.onLogout());
  };

  const mainMenuItems = [
    { id: "home", to: '/', labelDesktop: "Dashboard", label: "Home", icon: Home },
    { id: "exchange", to: '/my/p2p', labelDesktop: "P2P Exchange", label: "Exchange", icon: RefreshCw },
    { id: "wallet", to: '/referral/system', labelDesktop: "Referral", label: "Referral", icon: Wallet },
    { id: "profile", to: '/mine', labelDesktop: "Mine", label: "Mine", icon: User },
  ]

  const secondaryMenuItems = [
    { id: "settings", to: '/update/security', labelDesktop: "Settings", icon: Settings },
  ]

  return (
    <div
      className={`relative flex h-full flex-col bg-gradient-to-b from-gray-900 to-black border-r border-purple-500/20 shadow-[4px_0_20px_rgba(149,76,233,0.15)] transition-all duration-300 ${
        open ? "w-64" : "w-20"
      }`}
    >
      <div className="flex h-16 items-center justify-center border-b border-purple-500/20 px-4">
        {open ? (
          <h1 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-cyan-400">
            {capitalizeFirstLetter(site_settings?.site_settings?.sitename)}
          </h1>
        ) : (
          <div className="h-10 w-10 rounded-full bg-gradient-to-r from-purple-500 to-cyan-500 flex items-center justify-center text-white font-bold">
            {site_settings?.site_settings?.sitename?.[0]}
          </div>
        )}
      </div>

      <button
        onClick={() => setOpen(!open)}
        className="absolute -right-3 top-20 flex h-6 w-6 items-center justify-center rounded-full bg-gradient-to-r from-purple-500 to-cyan-500 text-white shadow-lg"
      >
        {open ? <ChevronLeft size={14} /> : <ChevronRight size={14} />}
      </button>

      <div className="flex flex-col flex-1 overflow-y-auto py-6">
        <div className="px-3 space-y-1">
          {mainMenuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                setActiveTab(item.id)
                navigate(item.to)
              }}
              className={`flex w-full items-center rounded-lg px-3 py-2 text-left transition-colors ${
                activeTab === item.id
                  ? "bg-gradient-to-r from-purple-600/30 to-cyan-600/20 text-white"
                  : "text-gray-400 hover:bg-white/5 hover:text-purple-300"
              }`}
            >
              <item.icon
                className={`h-5 w-5 ${
                  activeTab === item.id ? "text-purple-400 filter drop-shadow-[0_0_8px_rgba(192,132,252,0.8)]" : ""
                }`}
              />
              {open && <span className="ml-3">{item.labelDesktop}</span>}
              {activeTab === item.id && open && (
                <span className="ml-auto h-2 w-2 rounded-full bg-gradient-to-r from-purple-400 to-cyan-400" />
              )}
            </button>
          ))}
        </div>

        <div className="mt-auto px-3 space-y-1">
          {secondaryMenuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => navigate(item.to)}
              className="flex w-full items-center rounded-lg px-3 py-2 text-left text-gray-400 transition-colors hover:bg-white/5 hover:text-purple-300"
            >
              <item.icon className="h-5 w-5" />
              {open && <span className="ml-3">{item.labelDesktop}</span>}
            </button>
          ))}

          <button onClick={doLogOutNowNow} className="flex w-full items-center rounded-lg px-3 py-2 text-left text-gray-400 transition-colors hover:bg-white/5 hover:text-red-300">
            <LogOut className="h-5 w-5" />
            {open && <span className="ml-3">Logout</span>}
          </button>
        </div>
      </div>
    </div>
  )
}
